import { Action, createReducer, on } from '@ngrx/store';
import * as XidroActions from '../_actions/xidroDevices';
import { FlowMetersModel, PressureSensorsModel, PumpSystemsModel, ZoneModel } from '../_models';

export interface XidroState {
  pumpSystems: PumpSystemsModel[];
  pressureMeters: PressureSensorsModel[];
  valves: ZoneModel[];
  flowMeters: FlowMetersModel[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

const initialState: XidroState = {
  pumpSystems: [],
  pressureMeters: [],
  valves: [],
  flowMeters: [],
  loading: false,
  loaded: false,
  error: null,
};

export const xidroReducer = createReducer(
  initialState,

  on(XidroActions.loadXidroDevices, (state) => ({
    ...state,
    loading: true,
    loaded: state.loaded,
    error: null,
  })),

  on(
    XidroActions.loadXidroDevicesSuccess,
    (state, { pumpSystems, pressureMeters, valves, flowMeters }) => ({
      ...state,
      pumpSystems,
      pressureMeters,
      valves,
      flowMeters,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(XidroActions.loadXidroDevicesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  }))
);

export function reducer(state: XidroState | undefined, action: Action) {
  return xidroReducer(state, action);
}
